var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import { SmileOutlined } from "@ant-design/icons";
import * as Ant from "antd";
import { XForm } from "@bluelibs/x-ui-admin";
import { Routes } from "@bundles/UIAppBundle";
import { Service, Inject } from "@bluelibs/core";
import { features } from "./features";
import { ReportsCollection, } from "@bundles/UIAppBundle/collections";
import { RichTextEditor } from "@bundles/UIAppBundle/components/RichTextEditor/RichTextEditor";
let ReportCreateForm = class ReportCreateForm extends XForm {
    build() {
        const { UIComponents } = this;
        const { t } = this.i18n;
        this.add([
            {
                id: "name",
                label: t("management.reports.fields.name"),
                name: ["name"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "description",
                label: t("management.reports.fields.description"),
                name: ["description"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "content",
                label: t("management.reports.fields.content"),
                name: ["content"],
                required: true,
                component: RichTextEditor,
            },
            {
                id: "isActive",
                label: t("management.reports.fields.isActive"),
                name: ["isActive"],
                required: true,
                initialValue: true,
                componentProps: {
                    defaultChecked: true,
                },
                component: (props) => {
                    return (_jsx(Ant.Checkbox, Object.assign({}, props, { onChange: (e) => {
                            props.onChange && props.onChange(e.target.checked);
                        } }), void 0));
                },
            },
        ]);
    }
    onSubmit(document) {
        const { t } = this.i18n;
        return this.collection
            .insertOne(document)
            .then(({ _id }) => {
            Ant.notification.success({
                message: t("generics.success"),
                description: t("management.reports.create_confirmation"),
                icon: _jsx(SmileOutlined, {}, void 0),
            });
            if (features.view) {
                return this.router.go(Routes.REPORTS_VIEW, {
                    params: {
                        id: _id,
                    },
                });
            }
            if (features.list) {
                return this.router.go(Routes.REPORTS_LIST);
            }
            if (features.edit) {
                return this.router.go(Routes.REPORTS_EDIT, {
                    params: {
                        id: _id,
                    },
                });
            }
        })
            .catch((err) => {
            Ant.notification.warn({
                message: t("generics.error"),
                description: t("generics.error_message"),
            });
        });
    }
};
__decorate([
    Inject(() => ReportsCollection),
    __metadata("design:type", typeof (_a = typeof ReportsCollection !== "undefined" && ReportsCollection) === "function" ? _a : Object)
], ReportCreateForm.prototype, "collection", void 0);
ReportCreateForm = __decorate([
    Service({ transient: true })
], ReportCreateForm);
export { ReportCreateForm };
